export default __webpack_public_path__ + "static/media/features4.778676e4.jpg";